//亚运会 full
import PlatfromCSMeetAsianGamesFull from '@containers/platfrom_compreSportsMeet/asianGamesFull_ASG.vue'

export default {
  PlatfromCSMeetAsianGamesFull,
}
